import {ApiClient} from '@hconnect/apiclient'
import {useLoginContext, useUserContext} from '@hconnect/login'
import {Content, LandingPage, LoadingSwitcher} from '@hconnect/uikit'

const Login: React.FC = () => {
  return (
    <LandingPage
      onClickButton={() => void ApiClient.loginFlow.startLoginProcess()}
      customLogoStyle={{
        height: '4rem'
      }}
    />
  )
}

interface LoginValidationWrapperProps {
  children: React.ReactElement
}

export const LoginValidationWrapper: React.FC<LoginValidationWrapperProps> = ({children}) => {
  const {isLoggedIn} = useLoginContext()
  const {loggedUser} = useUserContext()

  const Children = (
    <LoadingSwitcher variant="overlay" isLoading={loggedUser === null}>
      {loggedUser ? children : <Content style={{width: '100vw', height: '100vh'}} />}
    </LoadingSwitcher>
  )

  return isLoggedIn ? Children : <Login />
}
